const { request, gql } = require('graphql-request');
const pageResults = require('graph-results-pager');

const { graphAPIEndpoints } = require('./../constants')
const { timestampToBlock } = require('./../utils');

module.exports = {
    async buryBoneUserRewards({block = undefined, timestamp = undefined, last_id = ""} = {}) {
        block = block ? block : timestamp ? (await timestampToBlock(timestamp)) : undefined;
        block = block ? `block: { number: ${block} }` : "";

        const result = await request(graphAPIEndpoints.buryBone,
            gql`{
                bury(id: "0xf7a0383750fef5abace57cc4c9ff98e3790202b3", ${block}) {
                    id
                    totalSupply
                    users(first :1000, where: {id_gt : "${last_id}"}) {
                        id
                        tBone
                    }
                }
            }`
        );

        return buryBoneUsersRewards.callback(result.bury);
    },

    async buryBoneUsers({block = undefined, timestamp = undefined} = {}) {
        return pageResults({
            api: graphAPIEndpoints.buryBone,
            query: {
                entity: 'buries',
                selection: {
                    block: block ? { number: block } : timestamp ? { number: await timestampToBlock(timestamp) } : undefined,
                },
                properties: buryBoneUsersCallback.properties
            }
        }).then(results => buryBoneUsersCallback.callback(results)).catch(err => console.log(err));
    }
}

const buryBoneUsersCallback = {
    properties: [
        'id',
        'users {id, tBone, tBoneIn, tBoneOut, tBoneMinted, tBoneBurned, tBoneOffset, tBoneAge, tBoneAgeDestroyed, boneStaked, boneStakedUSD, boneHarvested, boneHarvestedUSD, boneOut, boneIn, usdIn, boneOffset, usdOffset}',
        'totalSupply'
    ],

    callback(results) {
        return results.map(entry => ({
            id : entry.id,
            totalSupply: entry.totalSupply,
            users : entry.users.map(eachUser => ({
                id : eachUser.id,
                tBone : Number(eachUser.tBone),
                tBoneIn : Number(eachUser.tBoneIn),
                tBoneOut : Number(eachUser.tBoneOut),
                tBoneMinted : Number(eachUser.tBoneMinted),
                tBoneBurned : Number(eachUser.tBoneBurned),
                tBoneOffset : Number(eachUser.tBoneOffset),
                tBoneAge : Number(eachUser.tBoneAge),
                tBoneAgeDestroyed : Number(eachUser.tBoneAgeDestroyed),
                boneStaked : Number(eachUser.boneStaked),
                boneStakedUSD : Number(eachUser.boneStakedUSD),
                boneHarvested : Number(eachUser.boneHarvested),
                boneHarvestedUSD : Number(eachUser.boneHarvestedUSD),
                boneOut : Number(eachUser.boneOut),
                boneIn : Number(eachUser.boneIn),
                usdIn : Number(eachUser.usdIn),
                boneOffset : Number(eachUser.boneOffset),
                usdOffset : Number(eachUser.usdOffset)
            }))
        }))
    }
};

const buryBoneUsersRewards = {
    properties: [
        'id',
        'users {id, tBone}',
        'totalSupply'
    ],

    callback(results) {
        return {
            id : results.id,
            totalSupply: Number(results.totalSupply),
            users : results && results.users ? results.users.map(eachUser => ({
                id : eachUser.id,
                tBone : Number(eachUser.tBone)
            })) : []
        }
    }
}